import React from "react";
import styled, { css } from "styled-components";
import { rem } from "polished";

import CheckIcon from "../../assets/img/check-icon.svg";

const Title = styled.h5`
	font-style: normal;
	font-weight: 700;
	font-size: ${rem(15)};
	line-height: 1.33;
	font-family: Sans-serif;
	display: flex;
`;

const PriceEl = styled.span`
	margin-top: ${rem(4)};
	display: block;
	font-family: Sans-serif;
	font-size: ${rem(13)};
	line-height: 1;
`;

const HiddenInput = styled.input`
	position: absolute;
	left: ${rem(14)};
	top: ${rem(20)};
	opacity: 0;
	width: 0;
	height: 0;
`;

const SideNotesEl = styled.div`
	font-size: ${rem(13)};
	line-height: 1.5;
	color: #5c5e62;
	margin-top: ${rem(5)};
	margin-bottom: ${rem(20)};
	font-family: Sans-serif;

	strong {
		font-weight: 700;
	}

	ul {
		li {
			padding-left: ${rem(15)};
			position: relative;

			&::before {
				content: "";
				background: url(${CheckIcon});
				background-size: contain;
				background-repeat: no-repeat;
				background-position: center center;
				position: absolute;
				width: ${rem(10)};
				height: ${rem(12)};
				left: 0;
				top: ${rem(4)};
			}
		}
	}
`;

const SelectEl = styled.div`
	position: relative;
	margin-top: ${rem(6)};
`;

const Option = styled.label`
	position: relative;
	cursor: pointer;
	display: inline-block;
	border-radius: 999em;
	border: 0;
	position: relative;
	margin-top: ${rem(10)};
	border: 1px solid #c9c9c9;
	transition: 0.3s;

	${({ checked }) =>
		checked &&
		css`
			border: 1px solid #cc6f4c;
			box-shadow: inset 0px 0px 0px 1px #cc6f4c;
		`}

	${({ disabled }) =>
		disabled &&
		css`
			opacity: 0.4;
		`}

  &:focus {
		outline: none;
	}
`;

const Color = styled.div`
	width: ${rem(48)};
	height: ${rem(48)};
	border-radius: 999em;
	margin: 3px;

	background-size: cover;
	background-repeat: no-repeat;
	background-position: center;
`;

const SelectOptionsWrapper = styled.div`
	display: flex;
	justify-content: space-between;
`;

const SelectElInfo = styled.div`
	display: flex;
	margin-top: ${rem(10)};

	${PriceEl} {
		font-weight: 400;
		font-size: ${rem(15)};
		line-height: 1.33;
		margin-top: 0;
	}
`;

const ColorPicker = ({
	options,
	selectedOption,
	sideNotes,
	fieldId,
	onChange,
	isDisabled,
	active,
	setActiveAccessories,
	disableColorCondition = () => false,
}) => {
	return (
		<>
			<SelectEl>
				<SelectOptionsWrapper>
					{options.map((option, index) => (
						<Option
							key={index}
							htmlFor={`${fieldId}-${option.id}`}
							checked={selectedOption?.id === option.id}
							disabled={isDisabled || disableColorCondition(option)}
						>
							<HiddenInput
								id={`${fieldId}-${option.id}`}
								checked={selectedOption?.id === option.id}
								type="radio"
								onChange={() => {
									onChange({
										id: option.id,
										label: option.label,
										price: option.price,
									});
								}}
								disabled={isDisabled || disableColorCondition(option)}
							/>
							<Color style={{ backgroundImage: `url(${option.image})` }} />
						</Option>
					))}
				</SelectOptionsWrapper>

				{selectedOption && (
					<SelectElInfo>
						<Title>{selectedOption?.label}</Title>
						{/*<PriceEl>&nbsp;-&nbsp;£{selectedOption?.price}</PriceEl>*/}
					</SelectElInfo>
				)}
			</SelectEl>

			{sideNotes && (
				<SideNotesEl dangerouslySetInnerHTML={{ __html: sideNotes }} />
			)}
		</>
	);
};

export default ColorPicker;
